import { Directive, ElementRef, EventEmitter, OnDestroy, OnInit, Output, HostListener } from '@angular/core';
import { Subscription } from 'rxjs';

@Directive({
    selector: '[div-focusout]'
})

export class DivFocusoutDirective {
    @Output() clickElsewhere: EventEmitter<Object>;

    constructor(private _elRef: ElementRef) {
        this.clickElsewhere = new EventEmitter();
    }

    @HostListener('document:click', ['$event.target'])
    public onClick(target) {
        const clickedInside = this._elRef.nativeElement.contains(target);
        if (!clickedInside) {
            this.clickElsewhere.emit(target);
        }
    }  
}